export enum LifeCycleStage {
    IncompleteProfile = 'Incomplete profile',
    OccupiedAvailable = 'Occupied available',
    OccupiedUnAvailable = 'Occupied unavailable',
    Unoccupied = 'Unoccupied',
}

export const LifeCycleStageOption = [
    { label: LifeCycleStage.Unoccupied, value: LifeCycleStage.Unoccupied },
    { label: LifeCycleStage.OccupiedAvailable, value: LifeCycleStage.OccupiedAvailable },
    { label: LifeCycleStage.OccupiedUnAvailable, value: LifeCycleStage.OccupiedUnAvailable },
    { label: LifeCycleStage.IncompleteProfile, value: LifeCycleStage.IncompleteProfile },
]

export const LifeCycleAPIMapping: Record<LifeCycleStage, string> = {
    [LifeCycleStage.IncompleteProfile]: 'incomplete_profile',
    [LifeCycleStage.OccupiedAvailable]: 'occupied_available',
    [LifeCycleStage.OccupiedUnAvailable]: 'occupied_unavailable',
    [LifeCycleStage.Unoccupied]: 'unoccupied',
}

export enum SkillValidationValue {
    ResumeExtracted = 'resumeExtracted',
    SelfDisclosed = 'selfDisclosed',
    QualificationTasks = 'qualificationTasks',
    FTSExam = 'ftsExam',
    ProjectPerformance = 'projectPerformance',
}

export const SkillValidationOptions = [
    { id: 1, label: 'Resume Extracted', value: SkillValidationValue.ResumeExtracted },
    { id: 2, label: 'Self Disclosed', value: SkillValidationValue.SelfDisclosed },
    { id: 3, label: 'Qualification Tasks', value: SkillValidationValue.QualificationTasks },
    { id: 4, label: 'FTS Exam', value: SkillValidationValue.FTSExam },
    { id: 5, label: 'Project Performance', value: SkillValidationValue.ProjectPerformance },
]

export const CSVFileName = 'Experts-list.csv'

export const ExportTableHeader = [
    'Authal ID',
    'Name',
    'Email',
    'Skill',
    'Skill-level',
    'Location',
    'Languages',
    'Years of experience',
    'Expertise areas',
    'Occupation',
    'Education details',
    'Skill validation details',
    'Lifecycle stage',
    'Talent Studio profile',
]

export const ExpertDetailsMapping: Record<string, string> = {
    country: 'Location',
    occupation: 'Occupation',
    email: 'Email',
    yearsOfExperience: 'Experience',
    language: 'Language',
}

export const EducationDegreeMapping: Record<string, string> = {
    'Doctoral or equivalent': 'Doctoral',
    'Master or equivalent': 'Master',
    'Bachelor or equivalent': 'Bachelor',
    'Short-cycle tertiary education': 'Short-cycle tertiary',
    'Post-secondary education': 'Post secondary',
    'Upper secondary education': 'Upper secondary',
    'Lower secondary education': 'Lower secondary',
    'Primary education': 'Primary',
    Other: 'Other',
}

export const SkillValidationPriorityOrder = [
    'Project Performance',
    'FTS Exam',
    'Qualification Tasks',
    'Self-Disclosed',
    'Resume Extracted',
]

export const SkillLevelPriorityOrder = ['Advance', 'Intermediate', 'Beginner']

export const EducationDetailsPriorityOrder = [
    'Doctoral or equivalent',
    'Master or equivalent',
    'Bachelor or equivalent',
    'Short-cycle tertiary education',
    'Post-secondary education',
    'Upper secondary education',
    'Lower secondary education',
    'Primary education',
    'Other',
]

export const EmptyTableText = {
    NoExpertsFound: 'No experts found matching the applied filters',
    NoFiltersApplied: 'Apply a filter to search for experts',
    NoSkillsFound: 'No skills found',
}

export const YearsOfExperienceRange = {
    min: 0,
    max: 65,
}
